module.exports = __webpack_public_path__ + "img/20201222.3a2a1eb8.png";